import React from 'react'
import Flex from 'typescript-styled-flex'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { connect } from 'react-redux'
import { Radio } from '../../../components/FormBuilder'
import { IStore } from '../../../reducers'
import getSliderTab from '../../../reducers/userAccount/selectors/getSliderTab'
import setSliderTab from '../../../actions/userAccount/limit/setSliderTab'
import ArrowButton from './ArrowButton'

function Slider({ children, card, setCard }) {
  function nextCard(): void {
    if (card === React.Children.count(children) - 1) {
      setCard(0)
    } else {
      setCard(card + 1)
    }
  }

  function prevCard(): void {
    if (card === 0) {
      setCard(React.Children.count(children) - 1)
    } else {
      setCard(card - 1)
    }
  }

  function selectCard(index: number) {
    return function() {
      setCard(index)
    }
  }

  const childrenArray = React.Children.toArray(children)

  return (
    <Flex
      full={true}
      alignCenter={true}
      justifyCenter={true}
      column={true}
      style={{ alignSelf: 'stretch', height: 'auto' }}
    >
      <Flex full={true} alignCenter={true} justifyBetween={true} row={true}>
        <ArrowButton style={{ marginRight: '10px' }} onClick={prevCard}>
          <FiChevronLeft />
        </ArrowButton>
        <Flex style={{ minWidth: '0' }}>{childrenArray[card]}</Flex>
        <ArrowButton style={{ marginLeft: '10px' }} onClick={nextCard}>
          <FiChevronRight />
        </ArrowButton>
      </Flex>
      <Flex
        alignCenter={true}
        justifyCenter={true}
        row={true}
        style={{ marginLeft: '-10px' }}
      >
        {childrenArray.map((_, index) => (
          <Radio.Field
            wrapperStyle={{ cursor: 'pointer', marginLeft: '10px' }}
            temporaryValue={index}
            value={card}
            onClick={selectCard(index)}
          />
        ))}
      </Flex>
    </Flex>
  )
}

export default connect(
  (state: IStore) => ({
    card: getSliderTab(state),
  }),
  (dispatch) => ({
    setCard: (tab) => dispatch(setSliderTab(tab)),
  }),
)(Slider)
